import { FC } from 'react';
import MuiFormControlLabel, {
  FormControlLabelProps,
} from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';

type Props = FormControlLabelProps & {
  alignItems?: 'center' | 'flex-start';
  justifyContent?:
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
};

const StyledFormControlLabel = styled(MuiFormControlLabel, {
  shouldForwardProp: (prop) =>
    prop !== 'alignItems' && prop !== 'justifyContent',
})<Pick<Props, 'alignItems' | 'justifyContent'>>((props) => ({
  alignItems: props.alignItems,
  justifyContent: props.justifyContent,
}));

const FormControlLabel: FC<Props> = ({ ...props }) => {
  return <StyledFormControlLabel {...props} />;
};

export default FormControlLabel;
